import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectSupervisorsStyle } from './style/ProjectSupervisorsStyle';

interface ProjectSupervisorsProps {
  style: ProjectSupervisorsStyle;
}

export class ProjectSupervisors extends ValueObject<ProjectSupervisorsProps> {
  get style(): ProjectSupervisorsStyle {
    return this.props.style;
  }

  set style(style: ProjectSupervisorsStyle) {
    this.props.style = style;
  }

  private constructor(props: ProjectSupervisorsProps) {
    super(props);
  }

  static create(props: ProjectSupervisorsProps): ProjectSupervisors {
    return new ProjectSupervisors(props);
  }
}
